import olScaleLine from './../../node_modules/ol/control/ScaleLine.js';
import * as olproj from './../../node_modules/ol/proj.js';

export default class ScaleLine extends olScaleLine {
    constructor(options) {
        super(options);
    }

    _getPointResolutionMeters(proj, resolution, center) {
        const mpu = proj.getMetersPerUnit();
        return olproj.getPointResolution(proj, resolution / mpu, center, 'm') * mpu;
    }

    getResolutionForScale(scale, center, proj, thismap, resolu) {
        const INCHES_PER_METER = 39.37;
        const DEFAULT_DPI = 25.4 / 0.28;
        const SCREEN_DPI = 96;

        proj = proj
            ? proj
            : thismap
                ? thismap
                    .getView()
                    .getProjection()
                : this.viewState_.projection;
        center = center
            ? center
            : thismap
                ? thismap
                    .getView()
                    .getCenter()
                : this.viewState_.center;

        let dpi;
        if (resolu) {
            dpi = resolu === 150
                ? DEFAULT_DPI
                : DEFAULT_DPI * 2;
        } else {
            dpi = this.dpi_ || DEFAULT_DPI;
        }

        const pointResMeters = this._getPointResolutionMeters(proj, 1, center);

        return scale / (pointResMeters * INCHES_PER_METER * dpi);
    }

    getScaleForResolutionGro = function (thismap) {
        var t = olproj.getPointResolution(
                thismap.getView().getProjection(),
                thismap.getView().getResolution(),
                thismap.getView().getCenter()
            ),
            e = this.dpi_ || 25.4 / .28,
            r = thismap
                .getView()
                .getProjection()
                .getMetersPerUnit();

        e = this.dpi_ || 96;

        var result = parseFloat(t.toString()) * r * 39.37 * e;

        return result;
    };

    getScaleForResolutionV1 = function (thismap) {
        var t = olproj.getPointResolution(
                thismap.getView().getProjection(),
                thismap.getView().getResolution(),
                thismap.getView().getCenter()
            ),
            e = this.dpi_ || 25.4 / .28,
            r = thismap
                .getView()
                .getProjection()
                .getMetersPerUnit();

        e = this.dpi_ || 96;

        var result = parseFloat(t.toString()) * r * 39.37 * e;

        return result;
    };

}